import { useEffect } from "react";
import { useLocation } from "react-router";
import { useHelpDrawer } from "src/contexts/HelpDrawerContext";
import useRouteHelp from "src/hooks/useRouteHelp";

export default function HelpRouteSync(): null {
    const location = useLocation();
    const topicKey = useRouteHelp();
    const { syncRoute } = useHelpDrawer();
    const navigationToken = location.state?.helpNavigationToken;
    useEffect(() => {
        syncRoute(topicKey, navigationToken);
    }, [location.key, location.pathname, location.search, topicKey, syncRoute, navigationToken]);
    return null;
}
